import { ChangeDetectorRef, Component, ElementRef, HostBinding, OnInit } from '@angular/core';

import { FormBuilder, FormControl, FormGroup } from '@angular/forms';

import { ActivatedRoute, Router } from '@angular/router';

import { NotificationService } from 'src/app/Service/notification.service';

import { OtherService } from 'src/app/Service/other.service';

import { GurdServiceService } from 'src/app/Service/gurd-service.service';

import { AudioRecordingService } from 'src/app/Service/audio-recording.service';

import { DomSanitizer } from '@angular/platform-browser';

import axios from 'src/app/Service/axios';

declare let $: any;

@Component({

  selector: 'app-periodic-visits',

  templateUrl: './periodic-visits.component.html',

  styleUrls: ['./periodic-visits.component.css']

})

export class PeriodicVisitsComponent implements OnInit {

  list_PeriodicVisit: any[] = [];

  list_Items: any = [];

  lstPeriodicVisits_Result: any[] = [];

  list_ResultItems = [];

  list_ValueItems = [];

  bViewMode: boolean = false;

  acssess: any;

  audioRecordedTime: any;

  audioBlobUrl: any = '';

  audioSrcUrl: any = '';

  audioBlob: any;

  audioName: any;

  isAudioRecording: boolean = false;

  audio_Obj: any = {};

  SRC_IMAGE = ''

  searchModel: FormGroup = this.formBuilder.group({

    iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),

    strSession: this.gurdService.decrypt(window.localStorage.getItem('Session')!),

    strUnitID: new FormControl(''),

    tiInsepecatonOrVisit: new FormControl(1),

  })

  periodicVisits_Model: FormGroup = this.formBuilder.group({

    iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),

    strSession: this.gurdService.decrypt(window.localStorage.getItem('Session')!),

    iPeriodicVisits: new FormControl(''),

    strUnitID: new FormControl(''),

    fLat: new FormControl(0),

    fLon: new FormControl(0),

    strComment: new FormControl(''),

    lstPeriodicVisits_Result: new FormControl('')

  })

  constructor(

    private notifyService: NotificationService,

    private router: Router,

    public otherService: OtherService,

    private route: ActivatedRoute,

    private formBuilder: FormBuilder,

    private gurdService: GurdServiceService,

    private audioRecordingService: AudioRecordingService,

    private ref: ChangeDetectorRef,

    private sanitizer: DomSanitizer,

  ) {

    this.audioRecordingService.recordingFailed().subscribe(() => {

      this.isAudioRecording = false;

      this.ref.detectChanges();

    });

    this.audioRecordingService.getRecordedTime().subscribe((time) => {

      this.audioRecordedTime = time;

      if (time == '00:11') {

        this.stopAudioRecording();

        return this.notifyService.showError('حده اکثر زمان ضبط صدا 10 ثانیه است')

      }

      this.ref.detectChanges();

    });


  }

  ngOnInit(): void {

    var data = window.localStorage.getItem("menu") as any;

    this.acssess = JSON.parse(this.gurdService.decrypt(data));

    this.route.params.subscribe((params) => {

      this.searchModel.controls['strUnitID'].setValue(params['id']);

      this.periodicVisits_Model.controls['strUnitID'].setValue(params['id']);

      this.getAll_PeriodicVisit();

      this.getVisits_Item();

      // this.getPeriodicVisits_ResultItem();


    });

    this.audioRecordingService.getRecordedBlob().subscribe((data) => {

      var base64 = this.blobToBase64(data.blob);

      base64.then((result: any) => {

        result = result.replace('data:audio/wav;base64,', '')

        this.lstPeriodicVisits_Result[this.audio_Obj.Audio_index].strVoice = result;

      });

      this.audioBlob = data.blob;

      this.audioName = data.title;

      this.audioBlobUrl = this.sanitizer.bypassSecurityTrustUrl(URL.createObjectURL(data.blob));

      this.ref.detectChanges();

    });

  }

  getAll_PeriodicVisit = async (strUnitId?: number) => {

    this.otherService.Showspinner();

    const response = await axios.post(`PeriodicVisits_List`, this.searchModel.value);

    let res = JSON.parse(response.data);

    this.list_PeriodicVisit = res;

    this.otherService.nonespinner()

  }

  // کل ایتم ها و گزینه ها برای چیدمان در صفحه

  getVisits_Item = async () => {

    this.otherService.Showspinner();

    const response = await axios.post(`FInspection_Items_List`, this.searchModel.value);

    let res = JSON.parse(response.data);

    this.list_Items = res;

    // this.list_Items[3].tiImageRequired = 2;

    // this.list_Items[3].tiVoiceRequired = 2;

    this.initial_List_Result();

    this.otherService.nonespinner()

  }

  // مقد ار دهی اولیه مدل ارسالی برای سرور

  initial_List_Result() {

    this.list_Items.forEach((el: any) => {

      this.lstPeriodicVisits_Result.push({

        iPeriodicVisits: el.iPeriodicVisits,

        iFInspection_Items: el.iFInspection_Items,

        strComment: '',

        strFInspection_Items_Title: '',

        tiFInspection_Items_Title_Index: '',

        strImage: '',

        strVoice: '',

        bImageRequired: el.tiImageRequired == 2 ? true : false,

        bVoiceRequired: el.tiVoiceRequired == 2 ? true : false

      })

    })

  }

  getPeriodicVisits_ResultItem = async () => {

    // var model = this.searchModel.value

    // this.otherService.Showspinner();

    // const response = await axios.post(`PeriodicVisits_Result_List`, this.searchModel.value);

    // let res = JSON.parse(response.data);

    // this.list_ResultItems = res;

    // console.log(res)

    // this.otherService.nonespinner()

  }

  reset_Form_Value() {

    this.lstPeriodicVisits_Result = [];

    this.list_ValueItems = [];

    this.initial_List_Result();

    this.periodicVisits_Model.patchValue({

      iPeriodicVisits: '',

      fLat: 0,

      fLon: 0,

      strComment: '',

      lstPeriodicVisits_Result: ''

    })

    this.bViewMode = false;

    $('input[type="radio"]').prop('checked', false);

    $('input[type="checkbox"]').prop('checked', false);

    $('input[type="text"]').val('');

  }

  splitItems(item: string): string[] {

    return item.split(';')

  }

  setValue_Radio(index: number, strTitle: string, radioIndex: number) {

    this.lstPeriodicVisits_Result[index].strFInspection_Items_Title = strTitle;

    this.lstPeriodicVisits_Result[index].tiFInspection_Items_Title_Index = radioIndex;

  }

  setValue_Description(index: number, strComment: string) {

    this.lstPeriodicVisits_Result[index].strComment = strComment;

  }

  isCheckboxDisabled(item: any, value?: boolean): boolean {

    let isDisabled: boolean = false;

    if (this.periodicVisits_Model.get('tiFirst_FInspection_ResultItem')?.value.toString() == '') {

      isDisabled = false;

    }

    if (this.periodicVisits_Model.get('tiFirst_FInspection_ResultItem')?.value.toString() != '') {

      isDisabled = this.periodicVisits_Model.get('tiFirst_FInspection_ResultItem')?.value == item.tiFInspection_ResultItem ? false : true;

    }

    return isDisabled

  }

  setValue_ResultItem(item: any, value: boolean) {

    if (!value) {

      this.periodicVisits_Model.controls['tiFirst_FInspection_ResultItem'].setValue('');

    }

    if (value) {

      this.periodicVisits_Model.controls['tiFirst_FInspection_ResultItem'].setValue(item.tiFInspection_ResultItem);

    }

  }

  submit_Inspection = async () => {

    let iValid_Item: number = 0;

    let isFormValid: boolean = false;

    if (!this.lstPeriodicVisits_Result.length) {

      return this.notifyService.showError('لطفا موارد ستاره دار را وارد کنید');

    }

    this.lstPeriodicVisits_Result.forEach((el: any, index: number) => {

      if (el.tiFInspection_Items_Title_Index.toString() == "") return this.notifyService.showError('لطفا موارد ستاره دار را وارد کنید');

      if (el.bImageRequired && el.strImage == "") {

        return this.notifyService.showError(`لطفا تصویر  ( ${this.list_Items[index].strTitle} ) را وارد کنید`)

      }

      if (el.bVoiceRequired && el.strVoice == "") {

        return this.notifyService.showError(`لطفا صدای  ( ${this.list_Items[index].strTitle} ) را ضبط کنید`);

      }

      iValid_Item++;

      isFormValid = iValid_Item == this.lstPeriodicVisits_Result.length ? true : false;


    })

    if (isFormValid) {

      if (!this.list_ValueItems.length) {

        $.confirm({

          title: `آیا از ثبت اطلاعات اطمینان دارید ؟`,

          content: '',

          type: 'green',

          buttons: {

            ok: {

              text: "ثبت",

              btnClass: 'btn-success',

              keys: ['enter'],

              action: async () => {

                this.periodicVisits_Model.controls['lstPeriodicVisits_Result'].setValue(this.lstPeriodicVisits_Result);

                $("#PeriodicVisit_Modal").modal('hide');

                this.otherService.Showspinner();

                const response = await axios.post(`PeriodicVisits_Save`, this.periodicVisits_Model.value);

                this.otherService.nonespinner()

                let res = JSON.parse(response.data);

                if (res.bError || res.iResult == 0) {

                  $("#PeriodicVisit_Modal").modal('show');

                  return this.notifyService.showError(res.strError);

                }

                this.list_PeriodicVisit.push(res[0]);

                this.notifyService.showSuccess('با موفقیت ثبت شد');

                this.reset_Form_Value();

                $("#PeriodicVisit_Modal").modal('hide');

              }

            },

            cancel: {

              text: "لغو",

            }

          }

        });

      }

      if (this.list_ValueItems.length) {

        $.confirm({

          title: `آیا از ویرایش اطلاعات اطمینان دارید ؟`,

          content: '',

          type: 'blue',

          buttons: {

            ok: {

              text: "ویرایش",

              btnClass: 'btn-primary',

              keys: ['enter'],

              action: async () => {

                this.periodicVisits_Model.controls['lstPeriodicVisits_Result'].setValue(this.lstPeriodicVisits_Result);

                $("#PeriodicVisit_Modal").modal('hide');

                this.otherService.Showspinner();

                const response = await axios.post(`PeriodicVisits_Edit`, this.periodicVisits_Model.value);

                this.otherService.nonespinner()

                let res = JSON.parse(response.data);

                if (res.bError || res.iResult == 0) {

                  $("#PeriodicVisit_Modal").modal('show');

                  return this.notifyService.showError(res.strError);

                }

                this.notifyService.showSuccess('با موفقیت ویرایش شد');

                this.reset_Form_Value();

                $("#PeriodicVisit_Modal").modal('hide');

              }

            },

            cancel: {

              text: "لغو",

            }

          }

        });

      }

    }

  }

  //  دریافت همه ایتم ها , همراه با مقادیرشان

  async edit_Modal(item: any, isView: boolean) {

    var model = {

      iPeriodicVisits: item.iPeriodicVisits,

      iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),

      strSession: this.gurdService.decrypt(window.localStorage.getItem('Session')!),

    }

    this.otherService.Showspinner();

    const response = await axios.post(`PeriodicVisits_Result_List`, model);

    this.otherService.nonespinner()

    let res = JSON.parse(response.data);

    this.reset_Form_Value();

    if (isView) this.bViewMode = true;

    this.list_ValueItems = res;

    Object.keys(item).forEach(key => {

      this.periodicVisits_Model.get(key)?.setValue(item[key])

    })

    // DOM MANIPULATION

    this.list_Items.forEach((el: any, index: number) => {

      const splitItems = this.splitItems(el.strItems);

      splitItems.forEach((a: any, index: number) => {

        this.isRadioChecked_Edit(el, index)

      })

    })

    // SetValue to "lstFInspection_Result"

    this.list_ValueItems.forEach((a: any, index: number) => {

      if (this.lstPeriodicVisits_Result[index]) {

        this.lstPeriodicVisits_Result[index].strFInspection_Items_Title = a.strFInspection_Items_Title;

        this.lstPeriodicVisits_Result[index].strComment = a.strComment;

        this.lstPeriodicVisits_Result[index].tiFInspection_Items_Title_Index = a.tiFInspection_Items_Title_Index;

        this.lstPeriodicVisits_Result[index].strVoice = a.strVoice ? a.strVoice : '';

        this.lstPeriodicVisits_Result[index].strImage = a.strImage ? a.strImage : '';

      }

    })

    $("#PeriodicVisit_Modal").modal('show')


  }

  async remove_Inspection(item: any, index: number) {

    $.confirm({

      title: `آیا از حذف اطمینان دارید ؟`,

      content: '',

      type: 'red',

      buttons: {

        ok: {

          text: "حذف",

          btnClass: 'btn-danger',

          keys: ['enter'],

          action: async () => {

            var model = {

              iPeriodicVisits: item.iPeriodicVisits,

              iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),

              strSession: this.gurdService.decrypt(window.localStorage.getItem('Session')!),

            }

            this.otherService.Showspinner();

            const resp = await axios.post(`PeriodicVisits_Delete`, model);

            this.otherService.nonespinner();

            let res = JSON.parse(resp.data);

            if (res.bError || res.iResult == 0) return this.notifyService.showError(res.strError);

            this.list_PeriodicVisit.splice(index, 1);

            return this.notifyService.showSuccess('اطلاعات با موفقیت حذف شد');

          }

        },

        cancel: {

          text: "لغو",


        }

      }

    });

  }

  isRadioChecked_Edit(item: any, index: number) {

    this.list_ValueItems.some((el: any, i: number) => {

      if (el.iFInspection_Items == item.iFInspection_Items && el.tiFInspection_Items_Title_Index == index) {

        $(`input[type="radio"][name=${item.iFInspection_Items}]`)

          .eq(el.tiFInspection_Items_Title_Index)

          .prop('checked', true);

      }

      if (el.iFInspection_Items == item.iFInspection_Items && el.strComment.trim() != '') {

        // i + 1 ==> because first input is search box

        $('input[type="text"]').eq(i + 1).val(el.strComment)

      }

    });

  }

  ///AudioHandler

  startAudioRecording(item: any, index: number) {

    this.audio_Obj = {

      'Audio_index': index,

      'iFInspection_Items': item.iFInspection_Items,

      'tiVoiceRequired': item.tiVoiceRequired

    }

    navigator.mediaDevices.getUserMedia({ audio: true })

      .then(stream => {

        if (!this.isAudioRecording) {

          this.isAudioRecording = true;

          this.audioRecordingService.startRecording();

        }

      }).catch(err => {

        if (err.message == "Requested device not found") {

          this.notifyService.showError("سیستم شما دارای میکروفون نمی باشد")

        }

        else {

          alert("خطا در ضبظ صدا")

        }

      })

  }

  abortAudioRecording() {

    if (this.isAudioRecording) {

      this.isAudioRecording = false;

      this.audioRecordingService.abortRecording();

    }

  }

  stopAudioRecording() {

    if (this.isAudioRecording) {

      this.audioRecordingService.stopRecording();

      this.isAudioRecording = false;

    }

  }

  clearAudioRecordedData(item: any) {

    this.lstPeriodicVisits_Result.forEach((el: any, index: number) => {

      if (item.iFInspection_Items == el.iFInspection_Items) {

        this.lstPeriodicVisits_Result[index].strVoice = '';

        this.audioBlobUrl = null;

        this.audioSrcUrl = '';

        this.notifyService.showSuccess('صدا با موفقیت حذف شد')

      }

    })

  }

  blobToBase64(blob: any) {

    return new Promise((resolve, _) => {

      const reader = new FileReader();

      reader.onloadend = () => resolve(reader.result);

      reader.readAsDataURL(blob);

    });

  }

  isAudioRecorded(index: number): boolean {

    return this.lstPeriodicVisits_Result[index].strVoice != '' ? true : false

  }

  playAudio(index: number) {

    setTimeout(() => {

      this.audioSrcUrl = this.sanitizer.bypassSecurityTrustUrl(`data:audio/mp3;base64,` + this.lstPeriodicVisits_Result[index].strVoice);

      $("#PeriodicVisit_Modal").modal('hide');

      $("#play_audio").modal('show');

    }, 200);

  }

  closeAudio_Modal(isAll?: boolean) {

    $("#PeriodicVisit_Modal").modal(isAll ? 'hide' : 'show');

    $("#play_audio").modal('hide');

    $("#view_Uploaded").modal('hide');

    setTimeout(() => {

      this.audioSrcUrl = '';

      this.SRC_IMAGE = '';

    }, 200);

  }

  // UploaderHandler

  onFileInput(file: any, index: number) {

    let extension = file.name.split('.').pop();

    if (extension !== 'jpeg' && extension !== 'jpg') this.notifyService.showError(' فرمت قابل قبول فقط jpg است')

    if (extension === 'jpeg' || extension === 'jpg') {

      const reader: any = new FileReader();

      reader.readAsDataURL(file);

      reader.onload = async () => {

        var base64String = reader.result.toString();

        base64String = base64String.replace('data:image/jpeg;base64,', '');

        this.lstPeriodicVisits_Result[index].strImage = base64String

      };

    }


  }

  isUploaded(index: number): boolean {

    return this.lstPeriodicVisits_Result[index].strImage != '' ? true : false

  }

  clearUploaded(index: number) {

    this.lstPeriodicVisits_Result[index].strImage = ''

    this.notifyService.showSuccess('تصویر با موفقیت حذف شد')

  }

  view_Uploaded(index: number) {

    this.SRC_IMAGE = `data:image/jpeg;base64,` + this.lstPeriodicVisits_Result[index].strImage;

    $("#PeriodicVisit_Modal").modal('hide');

    $("#view_Uploaded").modal('show');

    setTimeout(() => {

      this.fullScreen_Image()

    }, 600);


  }

  fullScreen_Image() {

    const image_Element = $("#fullScreen_");

    image_Element.toggleClass('full-screen');

  }



}
